(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-timer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function targetFor(el) {
    var type = el.getAttribute('data-type');
    if (type === 'evergreen') {
      var key = 'furahaSalesTimer_' + el.getAttribute('data-section-id');
      var durMs = parseInt(el.getAttribute('data-duration'), 10) || 0;
      var restart = el.getAttribute('data-restart') === 'true';
      var now = Date.now();
      var end = parseInt(localStorage.getItem(key), 10);
      if (!end || isNaN(end) || (end <= now && restart)) {
        end = now + durMs;
        try { localStorage.setItem(key, String(end)); } catch (e) {}
      }
      return end;
    }
    // Fixed deadline
    var date = el.getAttribute('data-end-date');
    var time = el.getAttribute('data-end-time') || '00:00';
    if (!date) { return NaN; }
    if (time.length === 5) { time += ':00'; }
    var offset = el.getAttribute('data-utc-offset') || '';
    return new Date(date + 'T' + time + offset).getTime();
  }

  function expire(el) {
    if (el._stTimer) { clearInterval(el._stTimer); el._stTimer = null; }
    if (el.getAttribute('data-expired-behavior') === 'hide') {
      el.style.display = 'none';
      return;
    }
    var timer = el.querySelector('.sales-timer__timer');
    var expired = el.querySelector('.sales-timer__expired');
    var btn = el.querySelector('.sales-timer__btn');
    if (timer) { timer.hidden = true; }
    if (btn) { btn.hidden = true; }
    if (expired) { expired.hidden = false; }
  }

  function initTimer(el) {
    if (el.dataset.stReady === '1') { return; }
    el.dataset.stReady = '1';

    var target = targetFor(el);
    var nums = {
      days: el.querySelector('[data-st="days"]'),
      hours: el.querySelector('[data-st="hours"]'),
      minutes: el.querySelector('[data-st="minutes"]'),
      seconds: el.querySelector('[data-st="seconds"]')
    };

    function render() {
      if (isNaN(target)) { return; }
      var diff = target - Date.now();
      if (diff <= 0) { expire(el); return; }

      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      if (nums.days) { nums.days.textContent = pad(d); }
      else { h += d * 24; } // fold days into hours when days hidden

      if (nums.hours) { nums.hours.textContent = pad(h); }
      if (nums.minutes) { nums.minutes.textContent = pad(m); }
      if (nums.seconds) { nums.seconds.textContent = pad(s); }
    }

    render();
    el._stTimer = setInterval(render, 1000);
  }

  function initAll(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('.sales-timer');
    for (var i = 0; i < nodes.length; i++) { initTimer(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('.sales-timer');
    if (el && el._stTimer) { clearInterval(el._stTimer); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
